import ProductDetailItem from "../components/products/productDetail/ProductDetailItem";
import { fetchProductDetail } from "../redux/thunks/productDetail";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../redux/store";
import { useParams } from "react-router";
import { ProductType } from "../types/productType";

 const ProductDetail = () => {
  const { id } = useParams();
  const products = useSelector(
    (state: RootState) => state.product.products
  );
  const product = products.filter((product:ProductType) => product._id == id )[0]
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(fetchProductDetail(id));
  }, [dispatch, id]);
  console.log(id,product,"productDetail")
  console.log(products,"products")
  return (
    <div>
      <ProductDetailItem productDetail={product} />
    </div>
  );
};
export default ProductDetail